<template>
  <div class="ml-2">
    <div
      class="d-flex justify-content-between card-rule"
      :class="{ 'selected-rule': isRuleSelected(ruleListData) }"
      :style="styleObject(ruleListData)"
      @click="selectedRule(ruleListData.id)"
    >
      <!-- :class="{
        'selected-rule': selectedId === ruleListData.id,
      }" -->
      <!-- TODO : expand click area -->
      <div class="d-flex justify-content-start align-items-center" v-b-toggle="'rule-' + ruleListData.id">
        <font-awesome-icon icon="chevron-right" class="mr-1" v-if="ruleListData.type ==='model' || ruleListData.type ==='regex'" />
        <span class="type-badge mr-1" :class="ruleListData.type">{{ getDisplayType }}</span>
        <p class="m-0 max-width-name" :class="ruleListData.type === '' ? 'text-no-type' : ''">{{ ruleListData.name }}</p>
      </div>

      <!-- Right Side -->
      <div class="d-flex align-items-center">
        <span class="icon" v-if="ruleListData.level !== 0" @click="removeRule(ruleListData)">
          <font-awesome-icon icon="trash"></font-awesome-icon>
        </span>
      </div>
    </div>
    <!-- recuesive component -->
    <b-collapse :id="'rule-' + ruleListData.id" :visible="ruleListData.level === 0">
      <rule-list
        class="test"
        v-for="rule in ruleListData.child"
        :key="rule.id"
        :selectedId="selectedId"
        @update:selectedId="setSelectedId"
        :rule-list-data="rule"
        @remove-rule="removeRule"
      ></rule-list>
    </b-collapse>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { BCollapse, VBToggle } from 'bootstrap-vue';

export default {
  name: 'ruleList',
  components: {
    'b-collapse': BCollapse,
  },
  directives: {
    'b-toggle': VBToggle,
  },
  props: { ruleListData: Object, selectedId: String },
  data() {
    return {
      typeList: [
        { value: 'model', text: 'Model' },
        { value: 'regex', text: 'Regex' },
        { value: 'rule_based_answer', text: 'Answer' },
        { value: 'next_to_state', text: 'Next to state' },
        { value: 'end', text: 'End' },
        { value: '', text: 'No type' },
      ],
      hasTypeList: true,
    };
  },
  computed: {
    ...mapGetters({
      previousSelectedPartialConfigId: 'nlpconfig/previousSelectedPartialConfigId',
    }),
    getDisplayType() {
      return this.typeList.find((item) => item.value === this.ruleListData.type)?.text || '';
    },
  },
  methods: {
    setSelectedId(id) {
      this.$emit('update:selectedId', id);
    },
    selectedRule(ruleId) {
      this.$emit('update:selectedId', ruleId);
    },
    isRuleSelected(rule) {
      if (this.selectedId === rule.id) {
        return true;
      }
      if (this.selectedId === null && this.previousSelectedPartialConfigId === rule.id) {
        return true;
      }
      return false;
    },
    removeRule(rule) {
      if (rule) {
        this.$emit('remove-rule', rule);
      }
    },
    isRuleActive(ruleId) {
      return this.selectedId === ruleId;
    },
    styleObject(rule) {
      return {
        'margin-left': `${rule.level * 3.5}px`,
      };
    },
  },
};
</script>

<style scoped>
.left-side-rule {
  /* width: 50px; */
  gap: 10px;
}
.card-rule {
  background-color: white;
  /* border: 1px solid #bebebe; */
  margin: 2px;
  padding: 8px;
  .text-no-type {
    color: #ef6767;
  }
}
.selected-rule {
  color: #fff;
  /* font-weight: bold; */
  background-color: #9cc7e0;
  border: 1px solid #9cc7e0;
}

.type-badge {
  color: var(--color, #646a8c);
  background-color: white;
  padding: 0px 5px;
  border-radius: 64px;
  border: 1px solid var(--color, #646a8c);
  font-size: 12px;
  margin-left: 8px;
  height: 18px;
  cursor: pointer;
}
/* add variable each type of badge have difference color */
.type-badge.model {
  --color: #3371ff;
}
.type-badge.regex {
  --color: #c964cf;
}
.type-badge.rule_based_answer {
  --color: #50cd89;
}
.type-badge.next_to_state {
  --color: #fea955;
}
.type-badge.end {
  --color: #59cbe8;
}
.max-width-name {
  word-break: break-all;
}
.icon:hover {
  cursor: pointer;
  color: #ef6767;
}
</style>
